export default __webpack_public_path__ + "static/media/s2s_image_3.ad77b0c4.png";